import { router } from '@inertiajs/react'

interface TeamOption {
  id: number
  name: string
}

interface MeetingFilterBarProps {
  basePath: string
  filters: Record<string, string>
  teams?: TeamOption[]
  totalCount?: number
  showScheduled?: boolean
}

export default function MeetingFilterBar({ basePath, filters, teams, totalCount, showScheduled = true }: MeetingFilterBarProps) {
  const selectClass = "px-3 py-1.5 text-sm border border-stone/30 rounded-lg bg-white text-text-primary focus:outline-none focus:ring-2 focus:ring-pinnacle-red/20 focus:border-pinnacle-red"

  const updateFilter = (key: string, value: string) => {
    const next: Record<string, string> = { ...filters, [key]: value }
    Object.keys(next).forEach(k => {
      if (next[k] === 'all') delete next[k]
    })
    delete next['page']
    router.get(basePath, next, { preserveState: true, preserveScroll: true, replace: true })
  }

  return (
    <div className="mb-6 flex flex-wrap items-center gap-3">
      {teams && (
        <div className="flex items-center gap-2">
          <label className="text-sm text-text-muted">Team:</label>
          <select
            value={filters.team_id || 'all'}
            onChange={e => updateFilter('team_id', e.target.value)}
            className={selectClass}
          >
            <option value="all">All teams</option>
            {teams.map(t => (
              <option key={t.id} value={t.id}>{t.name}</option>
            ))}
          </select>
        </div>
      )}
      <div className="flex items-center gap-2">
        <label className="text-sm text-text-muted">Status:</label>
        <select
          value={filters.status || 'all'}
          onChange={e => updateFilter('status', e.target.value)}
          className={selectClass}
        >
          <option value="all">All statuses</option>
          {showScheduled && <option value="scheduled">Scheduled</option>}
          <option value="in_progress">In Progress</option>
          <option value="completed">Completed</option>
          <option value="cancelled">Cancelled</option>
        </select>
      </div>
      {totalCount != null && (
        <span className="text-sm text-text-muted">
          {totalCount} meeting{totalCount !== 1 ? 's' : ''}
        </span>
      )}
    </div>
  )
}
